<template>
    <div class="content">
        <vs-row justify="center">
            <vs-col w="4">
                <div class="card-content">
                    <vs-card type="3" @click="changeMainContent(0)">
                        <template #title>
                            <h3>Resilience Indication in Eye movement</h3>
                        </template>
                        <template #img>
                            <img src="../assets/eyetracking-gif.gif" alt="">
                        </template>
                        <template #text>
                            <p>
                                Click to discover how eyetracking can unlock accessible resilience training.
                            </p>
                        </template>
                    </vs-card>
                </div>
            </vs-col>
            <vs-col w="4">
                <div class="card-content">
                    <vs-card type="3" @click="changeMainContent(1)">
                        <template #title>
                            <h3>Emotion through Eyetracking</h3>
                        </template>
                        <template #img>
                            <img src="../assets/tacet-eyes-emotion.gif" alt="">
                        </template>
                        <template #text>
                            <p>
                                Click to discover how eye movement gives us early warning signs of anxiety and stress.
                            </p>
                        </template>
                    </vs-card>
                </div>
            </vs-col>
            <vs-col w="4">
                <div class="card-content" @click="changeMainContent(2)">
                    <vs-card type="3">
                        <template #title>
                            <h3>Using TACET to learn from Eyetracking</h3>
                        </template>
                        <template #img>
                            <img src="../assets/tacet-cockpit.gif">
                        </template>
                        <template #text>
                            <p>
                                Click to discover how Aquila and Cineon are making advanced eyetracking accessible.
                            </p>
                        </template>
                    </vs-card>
                </div>
            </vs-col>
        </vs-row>
        <vs-row justify="center">
            <vs-col w="4">
                <vs-card style="padding: 3%">
                    <template #title>
                        <h3>{{mainTitle}}</h3>
                    </template>
                    <template #img>
                        <img :src="mainImg" alt="">
                    </template>
                    <template #text>
                        <p>
                            {{mainContent}}
                        </p>
                    </template>
                </vs-card>
            </vs-col>
        </vs-row>
    </div>
</template>

<script>
export default {
    name: "Eyetracking",
    data() {
        return {
            mainTitle: "Resilience Indication in Eye movement",
            mainContent: "Eye tracking is seen as the ‘window’ into a person’s wellbeing and expertise.  How a pilot obtains information from displays and instruments, and how that information is processed, is vital to effective decision making and situational awareness.",
            mainImg:  "src/assets/eyetracking-gif.gif",
            contentArray: [
                {
                    "title": "Resilience Indication in Eye movement",
                    "content": "Eye tracking is seen as the ‘window’ into a person’s wellbeing and expertise.  How a pilot obtains information from displays and instruments, and how that information is processed, is vital to effective decision making and situational awareness.",
                    "img": "../assets/eyetracking-gif.gif"
                },
                {
                    "title": "Emotion through Eyetracking",
                    "content": "Patterns of eye tracking behaviour can also provide insight into a pilot’s anxiety level and overall expertise.",
                    "img": "../assets/tacet-eyes-emotion.gif"
                },
                {
                    "title": "Using TACET to learn from Eyetracking",
                    "content": "Using state of the art eye tracking technology coupled with affordable VR hardware, TACET is exploiting the information that can be obtained for the benefit of the pilot.  Developing expertise by identifying situations that engender anxiety, and providing strategies to manage them.",
                    "img": "../assets/TACET-cockpit.gif"
                }
            ]
        }
    },
    methods: {
        changeMainContent(arrayLocation){
            this.mainTitle = this.contentArray[arrayLocation].title
            this.mainContent = this.contentArray[arrayLocation].content
            this.mainImg = this.contentArray[arrayLocation].img
        }
    }
}
</script>

<style scoped>
.content{
    margin-top: 10%;
    margin-left: 5%;
    margin-right: 5%;
}
.card-content{
    padding: 2px;
}
</style>